<template>
    <div class="card" :style="{ backgroundColor: cardColor }">
      <div class="card-image-container">
        <i class="fas fa-cross card-icon white-icon"></i>
      </div>
      <div class="card-content">
        <p style="font-size:22px;height:50px">{{ nome.toUpperCase() }}</p>
        <p><b>Falecimento: </b>{{ falecimento }}</p>
        <p><b>Sepultamento: </b> {{ sepultamento }}</p>
        <p><b>Tipo: </b> {{ quadra }}  <b> Quadra: </b>{{ letra }}</p>
        <p><b>Nº: </b>{{ jazigo }}</p>
        <button class="print-button" @click="handlePrint">
          <i class="fas fa-print"></i> Imprimir
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      nome: String,
      falecimento: String,
      sepultamento: String,
      quadra: String,
      letra: String,
      jazigo: String,
      cardColor: String,
    },
    methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.getMonth() + 1; // Lembre-se que os meses em JavaScript começam em 0 (janeiro é 0).
      const year = date.getFullYear();
      const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`;
      return formattedDate;
    },
    formatTime(dateTimeString) {
      const time = new Date(dateTimeString);
      const options = { hour: '2-digit', minute: '2-digit' };
      return time.toLocaleTimeString('pt-BR', options);
    },
    handlePrint() {
      // No totem, a impressão é feita via ponte nativa do Android (intent).
      if (window.AndroidInterface && typeof window.AndroidInterface.sendData === 'function') {
        this.sendDataToAndroid();
        return;
      }

      // Fora do totem (navegador comum, outro tablet, etc.), usa o diálogo de impressão nativo do navegador
      this.printFallback();
    },

    sendDataToAndroid() {
      const data = {
        nome: this.nome,
        falecimento: this.falecimento,
        sepultamento: this.sepultamento,
        quadra: this.quadra,
        letra: this.letra,
        jazigo: this.jazigo,
        cardColor: this.cardColor,
      };

      window.AndroidInterface.sendData(JSON.stringify(data));
    },

    printFallback() {
      const cleanup = () => {
        this.$el.classList.remove('is-printing');
        window.removeEventListener('afterprint', cleanup);
      };

      this.$el.classList.add('is-printing');
      window.addEventListener('afterprint', cleanup);
      window.print();
    },
  },
  };
  </script>
  
  <style>
  /* Estilize o card conforme necessário */
  .card {
    display: inline-block;
    width: 420px;
    height: 300px;
    margin: 10px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.35);
  }
  
  .card-icon {
    margin-top:10px;
    font-size: 26px; /* Tamanho da fonte para o ícone */
  }
  
  .white-icon {
    color: white; /* Cor branca para o ícone */
  }
  
  .card-content {
    color: white;
    padding: 5px;
  }

  .card-image {
    width: 100px;
    height: 100px;
    margin: 10px auto;
  }

  .print-button {
    display: none; /* Escondido por padrão; só aparece em modo tablet/touch */
    background-color: #3a7091;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 8px 16px;
    font-size: 14px;
    cursor: pointer;
    margin-top: 8px;
    transition: background-color 0.2s ease, transform 0.1s ease;
  }

  .print-button:hover {
    background-color: #2f5b76;
  }

  .print-button:active {
    transform: scale(0.96);
  }

  /* Em telas touch (tablets/totens), exibe o botão de impressão */
  @media (hover: none), (pointer: coarse) {
    .card {
      height: 340px;
    }

    .print-button {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      font-size: 18px;
      padding: 10px 22px;
      margin-top: 10px;
    }
  }

  /* Impressão via navegador (fallback quando não há ponte Android): isola só o card selecionado */
  @media print {
    body * {
      visibility: hidden;
    }

    .is-printing,
    .is-printing * {
      visibility: visible;
    }

    .is-printing {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      margin: 0;
      box-shadow: none;
      background-color: #fff !important;
    }

    .is-printing .card-content,
    .is-printing .card-content p,
    .is-printing .card-content b,
    .is-printing .white-icon {
      color: #000 !important;
    }

    .is-printing .print-button {
      display: none !important;
    }
  }
  </style>
  